"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _victory = require("victory");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * DoughnutChart renders a dataset as a pie chart. It is divided into segments,
 * the arc of each segment shows the proportional value of each piece of data.
 * The Chart is excellent at showing the relational proportions between data.
 */
const pieStyle = {
  data: {
    transition: 'ease-in-out .25s',
    cursor: 'pointer'
  }
};
const PieComponent = /*#__PURE__*/React.memo(({
  data,
  startAngle,
  width,
  height,
  padAngle,
  onPieceClick,
  selectedIndex,
  innerRadius,
  outerRadiusIncrease = 0,
  children,
  animationProps,
  ...otherProps
}) => {
  const [tweenedProps, animationInfo] = animationProps;
  const [selectedPiece, setSelectedPiece] = React.useState(selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : 0);

  const onClick = () => [{
    target: 'labels',
    mutation: datum => {
      setSelectedPiece(datum.index);
      if (onPieceClick) onPieceClick(datum);
    }
  }];

  return (0, _pragma.createFelaElement)("svg", {
    width: width,
    height: height
  }, (0, _pragma.createFelaElement)(_victory.VictoryPie, _extends({
    startAngle: startAngle,
    endAngle: Number(tweenedProps.endAngle),
    padAngle: padAngle,
    data: data,
    standalone: false,
    width: width,
    height: height,
    innerRadius: innerRadius || width / Math.PI,
    radius: ({
      index
    }) => {
      if (index === selectedPiece) return width / 2;
      return width / 2 - outerRadiusIncrease;
    },
    events: [{
      target: 'data',
      eventHandlers: {
        onClick
      }
    }],
    style: animationInfo !== null && animationInfo !== void 0 && animationInfo.terminating ? pieStyle : undefined
  }, otherProps)), children && children);
});

const DoughnutChartComponent = ({
  data,
  height,
  width,
  animationAngles = [90, 450],
  padAngle,
  colorScale,
  animation,
  duration = 1000,
  selectedIndex,
  outerRadiusIncrease,
  onPieceClick,
  children,
  ...otherProps
}) => (0, _pragma.createFelaElement)(_victory.VictoryAnimation, {
  easing: animation,
  duration: duration,
  data: [{
    endAngle: animationAngles[0]
  }, {
    endAngle: animationAngles[1]
  }]
}, (...args) => (0, _pragma.createFelaElement)(PieComponent, _extends({
  data: data,
  colorScale: colorScale,
  width: width,
  height: height,
  padAngle: padAngle,
  startAngle: animationAngles[0],
  onPieceClick: onPieceClick,
  selectedIndex: selectedIndex,
  outerRadiusIncrease: outerRadiusIncrease,
  animationProps: args
}, otherProps), children && children));

const DoughnutChart = /*#__PURE__*/React.memo(DoughnutChartComponent);
DoughnutChart.displayName = 'DoughnutChart';
var _default = DoughnutChart;
exports.default = _default;
//# sourceMappingURL=DoughnutChart.js.map